import React from "react";

// Renders a translation string with a tiny markup:
//   "\n" -> <br />, [[text]] -> highlighted <span>, __text__ -> <i>
const TOKEN = /(\[\[.*?\]\]|__.*?__|\n)/g;

const RichText = ({ text, highlightClass = "" }) => {
  const parts = text.split(TOKEN);

  return (
    <>
      {parts.map((part, index) => {
        if (part === "\n") return <br key={index} />;
        if (part.startsWith("[[") && part.endsWith("]]")) {
          return (
            <span key={index} className={highlightClass}>
              {part.slice(2, -2)}
            </span>
          );
        }
        if (part.startsWith("__") && part.endsWith("__")) {
          return <i key={index}>{part.slice(2, -2)}</i>;
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </>
  );
};

export default RichText;
